import {Injectable} from '@angular/core';

@Injectable()
export class TableExtensionService {
    constructor() {
    }

    onColumnResize(cols: Array<any>, event: any) {
        let colField = event.element.attributes['data-field'].nodeValue;
        let delta = event.delta;

        let itemIndex = cols.findIndex((item) => item.field === colField);

        if (itemIndex !== -1 && cols[itemIndex].width + delta > 0) {
            cols[itemIndex].width = cols[itemIndex].width + delta;
        }
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/zero-out-inventory/services/table-extension.service.ts